import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-post-calc-m',
  templateUrl: './post-calc-m.component.html',
  styleUrls: ['./post-calc-m.component.css']
})
export class PostCalcMComponent implements OnInit {
    argType;

    argValue;

    public grid?: GridOptions;

    constructor(private stateService: StateService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private loadGrid() {
        if (!!this.argType && !!this.argValue) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_postcalcm_grid')
                    .setLoadDataFunction({
                        method: 2519,
                        parameters: {
                            argtype: this.argType,
                            argvalue: this.argValue
                        }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
